// src/components/Navbar.js
import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = ({ user, role, schoolId, handleSignOut }) => {
  const base = schoolId ? `/${schoolId}` : '';
  const userEmail = user?.email?.toLowerCase() || '';
  const isPlatformAdmin =
    userEmail === 'mjnayr@yahoo.com' ||
    userEmail === 'rmelhus@nlcschool.org';

  return (
    <nav style={{ backgroundColor: '#1e3a8a', color: '#fff', padding: '1rem' }}>
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '1rem',
          flexWrap: 'wrap',
        }}
      >
        <div style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>
          <Link to={base || '/'} style={{ color: '#fff', textDecoration: 'none' }}>
            🎯 PBIS Portal
          </Link>
        </div>

        {user ? (
          <ul
            style={{
              listStyle: 'none',
              display: 'flex',
              gap: '1rem',
              margin: 0,
              padding: 0,
              alignItems: 'center',
              flexWrap: 'wrap',
            }}
          >
            {(role === 'admin' || role === 'staff') && (
              <>
                <li><Link to={`${base}/admin`} style={linkStyle}>Dashboard</Link></li>
                <li><Link to={`${base}/summary`} style={linkStyle}>Ticket Summary</Link></li>
                <li><Link to={`${base}/store-admin`} style={linkStyle}>Store Manager</Link></li>
                <li><Link to={`${base}/store-mode`} style={linkStyle}>Store Mode</Link></li>

                {role === 'admin' && (
                  <>
                    <li><Link to={`${base}/redemption-cards`} style={linkStyle}>Redemption Cards</Link></li>
                    <li><Link to={`${base}/admin-tools`} style={linkStyle}>Admin Tools</Link></li>

                    {/* ✅ NEW: Account tab */}
                    <li>
                      <Link to={`${base}/account`} style={linkStyle}>
                        ⚙️ Account
                      </Link>
                    </li>
                  </>
                )}
              </>
            )}

            {role === 'student' && (
              <>
                <li><Link to={`${base}/student`} style={linkStyle}>My Dashboard</Link></li>
                <li><Link to={`${base}/store`} style={linkStyle}>Store</Link></li>
                <li><Link to={`${base}/suggestions`} style={linkStyle}>Suggestions</Link></li>
              </>
            )}

            {isPlatformAdmin && (
              <li>
                <Link to="/platform-admin" style={linkStyle}>Platform Admin</Link>
              </li>
            )}

            <li>
              <button onClick={handleSignOut} style={logoutButtonStyle}>Log Out</button>
            </li>
          </ul>
        ) : (
          <ul style={{ listStyle: 'none', display: 'flex', gap: '1rem', margin: 0, padding: 0 }}>
            <li>
              <Link to="/about" style={linkStyle}>About</Link>
            </li>
          </ul>
        )}

        {user && !schoolId && (
          <div style={{ marginLeft: '1rem', fontSize: 12, opacity: 0.9 }}>
            <Link to="/" style={{ color: '#c7d2fe', textDecoration: 'underline' }}>
              set school namespace
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

const linkStyle = {
  color: '#fff',
  textDecoration: 'none',
  fontWeight: '500',
};

const logoutButtonStyle = {
  backgroundColor: '#ef4444',
  color: '#fff',
  border: 'none',
  padding: '0.25rem 0.75rem',
  borderRadius: '6px',
  cursor: 'pointer',
  fontWeight: '500',
};

export default Navbar;
